import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';

import { Button, Flex, Icon, Typography } from '@bookora/ui';

import { INTEGRATIONS_TAB_PATH } from './copy';

/**
 * «اتصال به سایت و سامانه‌های دیگه» in the «راهنما و پیشنهادها» hub — no tour,
 * one sentence and one way in. Shown only to whoever may manage integrations,
 * and only while the plan includes API access (a locked feature is advertised
 * by the plan screens, not by the help hub).
 */
export function IntegrationsHubSection(): JSX.Element {
  const navigate = useNavigate();
  return (
    <Flex vertical gap={8}>
      <Typography.Paragraph style={{ marginBlockEnd: 0 }}>
        سایت، اپ یا نرم‌افزار کلینیک رو با کلید API به تقویم و اطلاعات تماس بیماران متصل کنید تا
        نوبت‌ها در یک جا ثبت بشن. با وب‌هوک، تغییرهای نوبت به سامانهٔ شما اطلاع داده می‌شه.
      </Typography.Paragraph>
      <div>
        <Button icon={<Icon name="link" />} onClick={() => navigate(INTEGRATIONS_TAB_PATH)}>
          رفتن به اتصال‌ها
        </Button>
      </div>
    </Flex>
  );
}
